module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Bold.woff
// module id = 1892
// module chunks = 0